<template>
  <fieldset class="form-section">
    <legend class="green form-section__title">{{ title }}</legend>
    <slot />
  </fieldset>
</template>

<script>
export default {
  name: "FormSection",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.form-section {
  border: 1px solid #e3eceb;
  border-radius: 12px;
  padding: 16px 20px 20px;
  margin-bottom: 20px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 1px 4px rgba(47, 55, 64, 0.06);
}

.form-section__title {
  padding: 0 6px;
  font-size: 17px;
  font-weight: 700;
  /* colour comes from the global .green class */
}
</style>
